import { Resolver, FieldErrors } from 'react-hook-form';
import { validate, ValidationError } from 'class-validator';
import { plainToInstance } from 'class-transformer';

function mapErrors(
  errors: ValidationError[],
  parentPath: string[] = [],
  /* eslint-disable */
  result: any = {}
) {
  for (const error of errors) {
    const currentPath = [...parentPath, error.property];

    if (error.constraints) {
      const message = Object.values(error.constraints)[0];

      let cursor = result;

      for (let i = 0; i < currentPath.length - 1; i++) {
        cursor[currentPath[i]] ??= {};
        cursor = cursor[currentPath[i]];
      }

      cursor[currentPath[currentPath.length - 1]] = {
        type: 'validation',
        message,
      };
    }

    if (error.children?.length) {
      mapErrors(error.children, currentPath, result);
    }
  }

  return result;
}

export const ClassValidatorResolver =
  <T extends object, DTOInstance extends object>(
    DtoClass: new () => DTOInstance
  ): Resolver<T> =>
  async (data: T) => {
    const instance = plainToInstance(DtoClass, data, {
      enableImplicitConversion: true,
      exposeDefaultValues: true,
    });

    const validationErrors = await validate(instance, {
      forbidUnknownValues: false,
    });

    if (!validationErrors.length) {
      return {
        values: instance as unknown as T,
        errors: {},
      };
    }

    const errors = mapErrors(validationErrors);

    return {
      values: {},
      errors: errors as FieldErrors<T>,
    };
  };
